@if (escapedUrl()) {
  <ng2-pdfjs-viewer
    pagemode="thumbs"
    [showSpinner]="false"
    [viewerId]="viewerId()"
    [pdfSrc]="escapedUrl()"
  ></ng2-pdfjs-viewer>
}
